var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$options.name},[_c('h4',[_vm._v(_vm._s(_vm.currentListTitle))]),_vm._l((_vm.currentListToRender),function(item,index){return _c('div',{key:index},[_c('app-data-list-item',{directives:[{name:"show",rawName:"v-show",value:(
        item.children && item.children.length
        && (item.visible === undefined || item.visible === true)
      ),expression:"\n        item.children && item.children.length\n        && (item.visible === undefined || item.visible === true)\n      "}],attrs:{"item":item,"index":index},on:{"item-click":function (ref) {
        var childList = ref.childList;
        var index = ref.index;
        var registerId = ref.registerId;

        _vm.checkAndRenderChildData(childList, index);
        _vm.setRegisterId(registerId);
      }}})],1)})],2)}
var staticRenderFns = []

export { render, staticRenderFns }